import { useEffect, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { SelectableButton } from 'foundations-components/transitional/components/SelectableButton';
import { getUserInfo } from '../../_core/common/api/getUserInfo';
import getSalesPhoneNumber from '../../_core/common/adapters/getSalesPhoneNumber';
import { track } from '../../_core/common/eventTracking/tracker';
import { getUpgradeDataTrackingProperties } from '../../ums/utils';
import { StyledModal } from '../common/components/StyledModal';
import { MODAL_TYPES } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ReducedOptionsModalGD0532 = ({
  handleIframeSizeChange = () => {},
  hideBackground = false,
  onClose,
  upgradeData,
  onClickChat,
  onClickCall,
  modalRoot
}) => {
  const [isCallSectionVisible, setIsCallSectionVisible] = useState(false);
  const [firstName, setFirstName] = useState('');
  useEffect(() => {
    void getUserInfo().then(user => {
      setFirstName(user.user.first_name);
    });
  }, []);
  const handleChatBackButtonClick = () => {
    track('communicationMethodsInteraction', Object.assign({
      action: 'clicked unassignable phone back button'
    }, getUpgradeDataTrackingProperties(upgradeData)));
    handleIframeSizeChange(MODAL_TYPES.UNASSIGNABLE);
    setIsCallSectionVisible(false);
  };
  const handleClickCall = () => {
    onClickCall();
    handleIframeSizeChange(MODAL_TYPES.CALL_US);
    setIsCallSectionVisible(true);
  };
  const {
    phoneNumber,
    countryCode
  } = getSalesPhoneNumber();
  const optionalProps = modalRoot ? {
    rootNode: modalRoot
  } : {};
  return /*#__PURE__*/_jsxs(StyledModal, Object.assign({
    hideBackground: hideBackground,
    width: 650,
    use: "conversational",
    "data-test-id": isCallSectionVisible ? 'unassignable-selected-method-call' : 'unassignable-communication-methods-modal'
  }, optionalProps, {
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      marginBlockEnd: "400",
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: () => onClose({
          isClosedOnOptionsView: !isCallSectionVisible
        })
      }), /*#__PURE__*/_jsx(Text, {
        textAlign: "start",
        marginBlockStart: "-800",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.communicationMethods.expertTitle"
        })
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      paddingBlockEnd: "1000",
      alignItems: "start",
      display: "flex",
      children: isCallSectionVisible ? /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        "data-test-id": "communication-call-submit-success",
        paddingBlockStart: "500",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h4",
          margin: "0",
          children: phoneNumber
        }), countryCode && /*#__PURE__*/_jsx(Text, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `SharedI18nStrings.countryCodes.${countryCode}`
          })
        }), /*#__PURE__*/_jsx(Button, {
          onClick: handleChatBackButtonClick,
          use: "link",
          marginBlockStart: "800",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.communicationMethods.backButton"
          })
        })]
      }) : /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        gap: "300",
        children: [!isCallSectionVisible && /*#__PURE__*/_jsx(Text, {
          as: "h1",
          textAlign: "start",
          marginBlockEnd: "400",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.communicationMethods.expertSubtitle",
            options: {
              firstName
            }
          })
        }), /*#__PURE__*/_jsx(SelectableButton, {
          "data-test-id": "unassignable-chat",
          selected: false,
          size: "large",
          block: true,
          blockSize: "165px",
          title: /*#__PURE__*/_jsxs(Flex, {
            flexDirection: "row",
            gap: "400",
            alignItems: "center",
            paddingInlineStart: "400",
            paddingBlockEnd: "400",
            children: [/*#__PURE__*/_jsx(Illustration, {
              name: "contacts-chat",
              height: 90
            }), /*#__PURE__*/_jsxs(Flex, {
              flexDirection: "column",
              gap: "200",
              alignItems: "start",
              children: [/*#__PURE__*/_jsxs(Flex, {
                flexDirection: "row",
                gap: "200",
                alignItems: "center",
                children: [/*#__PURE__*/_jsx(Text, {
                  as: "h5",
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "upgrades.communicationMethods.chatWithUs"
                  })
                }), /*#__PURE__*/_jsx(Badge, {
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "upgrades.communicationMethods.recommended"
                  })
                })]
              }), /*#__PURE__*/_jsx(Text, {
                as: "p",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "upgrades.communicationMethods.getQuickAnswers"
                })
              })]
            })]
          }),
          onClick: () => onClickChat()
        }), /*#__PURE__*/_jsx(SelectableButton, {
          "data-test-id": "unassignable-call",
          size: "large",
          block: true,
          blockSize: "165px",
          title: /*#__PURE__*/_jsxs(Flex, {
            flexDirection: "row",
            gap: "400",
            alignItems: "center",
            paddingInlineStart: "400",
            paddingBlockEnd: "400",
            children: [/*#__PURE__*/_jsx(Illustration, {
              name: "calling-small",
              height: 90
            }), /*#__PURE__*/_jsxs(Flex, {
              flexDirection: "column",
              gap: "200",
              alignItems: "start",
              children: [/*#__PURE__*/_jsx(Text, {
                as: "h5",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "upgrades.communicationMethods.callUs"
                })
              }), /*#__PURE__*/_jsx(Text, {
                as: "p",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "upgrades.communicationMethods.getCustomerSupportNumber"
                })
              })]
            })]
          }),
          onClick: handleClickCall
        })]
      })
    })]
  }));
};